import { orchestrator } from "satcheljs";
import { resetOpenShiftsStore } from "sh-open-shift-store";
import setOpenShiftsInView from "../mutators/openShifts/setOpenShiftsInView";

export default orchestrator(resetOpenShiftsStore, function onResetGlobalOpenShiftsStore() {
    setOpenShiftsInView([]);
});
